// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2mNz6","buttons":"Footer_buttons__3Mmkf"};